<template>
    <div>
        <h3>Car insurance &mdash; Third party only</h3>
        <ul>
            <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Liability for damage to someone else</li>
            <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg>Insured driver protection</li>
        </ul>
        <p><a href="#" @click.prevent="toggleModal()">See all policy benefits</a></p>
        <modal
            v-if="this.modalOpen"
            :class="{ 'is-active': modalOpen }"
            v-on:childToParent="toggleModal"
            title="Third party only policy benefits"
            footer="Summary of policy only. Please refer to the policy wording for full details of cover."
        >
            <div class="content">
                <ul class="ticks">
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg><strong>$20,000,000</strong> - Liability for accidental loss to anyone else's property</li>
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg><strong>$20,000,000</strong> - Liability for accidental bodily injury to any person</li>
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg><strong>$10,000</strong> - Manslaughter Defence Costs (nil excess)</li>
                    <li><svg width="16" height="16" viewBox="0 0 28 28" ><use href="#initio_tick_icon" /></svg><strong>$3,000</strong> - Damage to your vehicle caused by uninsured driver (nil excess)</li>
                </ul>
            </div>
        </modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { toCurrency } from '@/helpers/currencyHelper.js'

export default {

computed: {
  ...mapGetters({
    answers: 'flattenedAnswers'
  })
},

  methods: {
    toCurrency,
    toggleModal: function () {
        this.modalOpen = ! this.modalOpen;
    }
  },
  data: function () {
      return {
        modalOpen: false
      }
  }
}
</script>